import { Component, OnInit} from '@angular/core';
import { ProjectService } from '../../../api/services/project.services';
import { Observable } from 'rxjs/Observable';
import { Worksheet } from '../../../api/models/worksheet';
import { Subscription } from 'rxjs/Subscription';
import { PreferencesService } from '../../../api/services/preferences.service';
import { AuthService } from '../../../api/services/auth.service';

@Component({
  selector: 'app-order-list',
  templateUrl: './order-list.component.html',
  styleUrls: ['./order-list.component.scss']
})
export class OrderListComponent implements OnInit {

  private timerSubscription: Subscription;

  orders: Observable<Worksheet[]>;

  currentMarket: string;

  constructor(private projectService: ProjectService,
    private preferencesService: PreferencesService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.preferencesService.getPreferences('USER', this.authService.getUserId())
      .subscribe(prefs => {
        this.currentMarket = prefs['current-market'].Value;
        this.orders = this.projectService.getWorksheetsByMarketId(this.currentMarket);
      });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/dashboard-orders/order-list/order-list.component.ts